export default __webpack_public_path__ + "static/media/mosaic-logo-text-white.54d13440.svg";